import { api } from "./axiosConfig";

export const getResults = async (data?: any) => {
  validateTokenExpiration();
  try {
    const userSessionStr = window.sessionStorage.getItem("ift.user");
    const accessToken = userSessionStr ? JSON.parse(userSessionStr)?.accessToken : "";
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
    const response = await api.post("/users", data, config);
    return response.data;
  } catch (error) {
    console.error("Get User Search Results Failed", error);
    throw error;
  }
};

export const postRTUpdates = async (data?: any) => {
  validateTokenExpiration();
  try {
    const userSessionStr = window.sessionStorage.getItem("ift.user");
    const accessToken = userSessionStr ? JSON.parse(userSessionStr)?.accessToken : "";
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
    const response = await api.post(`/users/${data.EMP_NUM}`, data, config);
    return response.data;
  } catch (error) {
    console.error("Post RT Updates Failed", error);
    throw error;
  }
};

export const validateTokenExpiration = () => {
  const userStr = window.sessionStorage.getItem("ift.user");
  const user = JSON.parse(userStr);
  const currentTime = Date.now();
  const expirationTime = user.exp * 1000;
  // if token is expired, remove session token to require new login
  if (currentTime > expirationTime) {
    window.sessionStorage.removeItem("ift.user");
    window.location.href = '/'
  }
}
